/* istanbul ignore next */
import('./bootstrapOrder');
/*
async boundary. splits out the initialization code of a larger chunk to avoid any additional round trips and improve performance.
See here for more info: https://webpack.js.org/concepts/module-federation/#troubleshooting
There is no need to use eager specifier for shared chunks in most cases and this is one fix for that.
.
*/
